const buttonClassName = 'js_product_specification_image_button';
const mainImageClassName = 'js_product_specification_main_image';
const subImageClassName = 'js_product_specification_image';

const classNameToHideMainImage = 'hide';
const classNameToEmphasizeSubImage =
  'product_specification_sub_image--selected';

/**
 * @param {string} index
 * @returns {string}
 */
const getMainImageIdByIndex = (index) => {
  return `js_product_specification_main_image_${index}`;
};

/**
 * @param {string} index
 * @returns {string}
 */
const getSubImageIdByIndex = (index) => {
  return `js_product_specification_sub_image_${index}`;
};

/**
 * @param {string} targetClass
 * @param {string} classToRemove
 */
const removeClassFromTarget = (targetClass, classToRemove) => {
  const elements = document.getElementsByClassName(targetClass);
  Array.from(elements).forEach((element) => {
    element.classList.remove(classToRemove);
  });
};

/**
 * @param {string} targetClass
 * @param {string} classToAdd
 */
const addClassToTarget = (targetClass, classToAdd) => {
  const elements = document.getElementsByClassName(targetClass);
  Array.from(elements).forEach((element) => {
    element.classList.add(classToAdd);
  });
};

/**
 * @param {string} index
 */
const changeMainImage = (index) => {
  addClassToTarget(mainImageClassName, classNameToHideMainImage);
  const target = document.getElementById(getMainImageIdByIndex(index));
  target.classList.remove(classNameToHideMainImage);
};

/**
 * @param {string} index
 */
const changeSubImage = (index) => {
  removeClassFromTarget(subImageClassName, classNameToEmphasizeSubImage);
  const target = document.getElementById(getSubImageIdByIndex(index));
  target.classList.add(classNameToEmphasizeSubImage);
};

window.addEventListener('DOMContentLoaded', () => {
  const elements = document.getElementsByClassName(buttonClassName);
  if (elements) {
    Array.from(elements).forEach((element) => {
      element.addEventListener('click', (event) => {
        const index = event.currentTarget.dataset.index;
        changeMainImage(index);
        changeSubImage(index);
      });
    });
  }
});
